import * as React from 'react';
import { Spinner } from 'fabric-spinner';

const MailListLoading = ({ className }) => <Spinner className={className} />;

export default MailListLoading;
